@let active = currentFilterConfig$ | async;
@let operators = active ? active.operators : [];
@let options =
  active && active.type === FilterType.SELECT && active.options
    ? active.options
    : [];

<form
  [formGroup]="form"
  rmsCompositeForm
  class="form-sm flex flex-col md:flex-row gap-2 flex-wrap w-full"
>
  <div class="flex flex-col sm:flex-row flex-1 md:flex-grow-0 gap-2 w-full">
    <mat-form-field class="h-[38px] w-full md:w-44" subscriptSizing="dynamic">
      <mat-select formControlName="filter">
        @for (c of config; track $index) {
          <mat-option
            [value]="c.filter"
            [disabled]="
              disabledFilters.includes(c.filter) &&
              form.controls.filter.value !== c.filter
            "
          >
            {{ c.label | translate }}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>

    @if (operators.length >= 2) {
      <mat-form-field class="h-[38px] w-full md:w-36" subscriptSizing="dynamic">
        <mat-select formControlName="operator">
          @for (operator of operators; track $index) {
            <mat-option [value]="operator">
              {{
                operatorsTranslations[operator] +
                  (active?.type === filterType.NUMBER ? "-amount" : "")
                  | translate
              }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
  </div>

  <div class="flex flex-col md:flex-row flex-1 md:flex-grow-0 gap-2 w-full">
    <div
      class="flex flex-col w-full"
      [class.hidden]="
        form.controls.type.value !== FilterType.SELECT ||
        form.controls.value.disabled
      "
    >
      <mat-form-field class="h-[38px] w-full md:w-80" subscriptSizing="dynamic">
        <mat-select
          formControlName="value"
          [placeholder]="'libs.filters.placeholder.select' | translate"
        >
          @for (option of options; track $index) {
            <mat-option [value]="option.value">
              {{ option.label | translate }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>

    @if (
      form.controls.type.value === FilterType.TEXT &&
      form.controls.value.enabled
    ) {
      <div class="flex flex-col w-full">
        <mat-form-field
          class="h-[38px] w-full md:w-80"
          subscriptSizing="dynamic"
        >
          <input
            matInput
            formControlName="value"
            [placeholder]="'libs.filters.placeholder.input' | translate"
            rmsControlError
            [label]="'libs.filters.placeholder.input' | translate"
            autocomplete="off"
            (keydown.enter)="onEmitFormValue()"
          />
        </mat-form-field>
      </div>
    }

    @if (
      form.controls.type.value === FilterType.NUMBER &&
      form.controls.value.enabled
    ) {
      <div class="flex flex-row w-full gap-2">
        <div class="flex flex-col w-full">
          <mat-form-field
            class="h-[38px] w-full md:w-80"
            subscriptSizing="dynamic"
            [matTooltipDisabled]="!specialLabel"
            [matTooltip]="specialLabel ? (specialLabel | translate) : ''"
          >
            <input
              matInput
              formControlName="value"
              [placeholder]="
                'libs.filters.placeholder.input' +
                  (active?.type === filterType.NUMBER ? '-number' : '')
                  | translate
              "
              rmsControlError
              [label]="'libs.filters.placeholder.input' | translate"
              rmsInputMask
              [mask]="numberInputMask"
              [unmask]="numberInputUnmask"
              autocomplete="off"
              (keydown.enter)="onEmitFormValue()"
            />
          </mat-form-field>
        </div>
        @if (specialLabel) {
          <mat-icon
            [matTooltip]="specialLabel | translate"
            class="icon-base mt-2"
            svgIcon="remix:System/information-line"
          ></mat-icon>
        }
      </div>
    }

    @if (
      form.controls.type.value === FilterType.DATE &&
      form.controls.valueFrom.enabled
    ) {
      <div class="flex flex-col w-full">
        <rms-datetime-picker
          class="h-[38px] w-full"
          formControlName="valueFrom"
          rmsControlError
          [label]="'libs.filters.placeholder.date-from' | translate"
          [min]="min"
          [max]="
            form.controls.valueTo.value && form.controls.valueTo.value.isValid
              ? form.controls.valueTo.value
              : max
          "
          [interval]="5"
        ></rms-datetime-picker>
      </div>
    }

    @if (
      form.controls.type.value === FilterType.DATE &&
      form.controls.valueTo.enabled
    ) {
      <div class="flex flex-col w-full">
        <rms-datetime-picker
          class="h-[38px] w-full"
          formControlName="valueTo"
          rmsControlError
          [label]="'libs.filters.placeholder.date-to' | translate"
          [min]="
            form.controls.valueFrom.value &&
            form.controls.valueFrom.value.isValid
              ? form.controls.valueFrom.value
              : min
          "
          [max]="max"
          [interval]="5"
        ></rms-datetime-picker>
      </div>
    }
  </div>
</form>
